var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _c(
                "div",
                [
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.dismissCountDown,
                        dismissible: "",
                        variant: "success"
                      },
                      on: {
                        dismissed: function($event) {
                          _vm.dismissCountDown = 0
                        },
                        "dismiss-count-down": _vm.countDownChanged
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.success_message) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.list_show == true
                    ? _c(
                        "div",
                        { staticClass: "col-lg-2 float-left override-padding" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-white col-12 override-padding",
                              staticStyle: {
                                "margin-top": "2px",
                                height: "30px",
                                "border-radius": "10px",
                                "font-weight": "bold"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addReseachers()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "cursor-pointer fa fa-plus",
                                staticStyle: {
                                  "font-size": "15px",
                                  "mpadding-left": "5px",
                                  "vertical-align": "middle"
                                }
                              }),
                              _vm._v(" Add CSR")
                            ]
                          )
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "col-lg-2 float-left override-padding" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-white col-12 override-padding",
                              staticStyle: {
                                "margin-top": "2px",
                                height: "30px",
                                "border-radius": "10px",
                                "font-weight": "bold"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.backLists()
                                }
                              }
                            },
                            [_vm._v("Back to List")]
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { clear: "both" } })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _vm.list_show == true
                ? _c(
                    "div",
                    {
                      staticClass: "list-users",
                      staticStyle: { "margin-top": "30px" }
                    },
                    [
                      _c(
                        "table-component",
                        {
                          ref: "table1",
                          attrs: {
                            data: _vm.fetchUserData,
                            "show-caption": false,
                            "show-filter": false,
                            "cache-key": 1,
                            "cache-lifetime": "0",
                            "filter-no-results": _vm.no_result()
                          }
                        },
                        [
                          _c("table-column", {
                            attrs: { show: "first_name", label: "First Name" }
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: { show: "last_name", label: "Last Name" }
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: {
                              show: "email",
                              sortable: true,
                              label: "Email"
                            }
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: {
                              show: "phone_number",
                              sortable: true,
                              label: "Phone Number"
                            }
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: { sortable: false, label: "Status" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(row) {
                                  return [
                                    row.enabled
                                      ? _c("span", [_vm._v("Active")])
                                      : _c("span", [_vm._v("Inactive")])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.add_user == true
                ? _c(
                    "div",
                    {
                      staticClass:
                        "content-main-wrapper signin-form add_account_form center"
                    },
                    [
                      _c("researcherform", {
                        attrs: {
                          first_name: _vm.first_name,
                          last_name: _vm.last_name,
                          phone_number: _vm.phone_number,
                          email_addr: _vm.email_addr,
                          password: _vm.password,
                          pw_confirm: _vm.pw_confirm,
                          submit: _vm.submit,
                          action: _vm.action,
                          roles: _vm.roles
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-10 float-left override-padding" }, [
      _c("h3", { staticClass: "d-inline heading" }, [_vm._v("Add CSR")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84f97678", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f97678","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/add_csr.vue
// module id = null
// module chunks = 